/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

type AssociatedUrl = "web" | "call" | "backend";

const knownHomeserversMap: Record<string, Record<AssociatedUrl, string>> = {
  // Переезд на новый дев-контур (13.08.2026): бэкенд звонков и сама звонилка
  // переехали в Cloud.ru. Адрес бэкенда берётся отсюда, а не из config.json
  // клиента, поэтому переключать контур надо именно здесь — иначе встроенный
  // виджет продолжит ходить на старый стенд, чем бы ни был открыт клиент.
  "matrix.winsolutions.ru": {
    web: "klava.winsolutions.ru",
    call: "call.klava.winsolutions.ru",
    // Прод ходит за своим бэкендом, а не за дев-сервером: раньше здесь стоял
    // element-back-dev.bots.winsolutions.ru, и браузеры пользователей прода
    // обращались к машине dev-контура.
    backend: "api.klava.winsolutions.ru",
  },
  "chat.avagroup.ru": {
    web: "klava.chat.avagroup.ru",
    call: "call.chat.avagroup.ru",
    backend: "back.chat.avagroup.ru",
  },
};

export function isKnownHomeserver(homeserver: string): boolean {
  return homeserver in knownHomeserversMap;
}

export function getHomeserverAssociatedDomain(
  homeserver: string,
  url: AssociatedUrl,
): string {
  return knownHomeserversMap[homeserver]?.[url] ?? window.location.host;
}
